<mat-card class="mat-elevation-z8">
  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
  <div>
    <h3>{{ 'analysis' | translate }}</h3>
  </div>
  <div>
  <mat-radio-group>
    <mat-radio-button style="margin-left: 2.5%;" *ngFor="let item of optionsFinder" (click)="showPie(item)"
      [checked]="(item === '3M')" value="{{item}}">{{ item | translate }}</mat-radio-button>
  </mat-radio-group>
  <br><br>
</div>
  <h4 *ngIf="pieCharts.length < 1">{{ 'no_data_interval' | translate }}</h4>
  <div *ngFor="let pie of pieCharts;let i =index ">
    <canvas height="80%" baseChart [data]="pie.data" [labels]="pie.labels" chartType="pie" legend="true"
      [colors]="pie.colors"></canvas>
    <br />

  </div>
</mat-card>
<br>
<mat-accordion>
  <mat-expansion-panel class="mat-elevation-z8">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h4>{{ 'productionList' | translate }} </h4>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <table mat-table [dataSource]="dataSourceProduction" matSort>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'name' | translate}} </th>
        <td mat-cell *matCellDef="let element"> {{ element.name}} </td>
      </ng-container>
      <ng-container matColumnDef="weight">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'weight' | translate}} </th>
        <td mat-cell *matCellDef="let element"> {{ element.weight}} </td>
      </ng-container>
      <ng-container matColumnDef="dateTime">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'datetime' | translate}} </th>
        <td mat-cell *matCellDef="let element"> {{element.dateTime | date:'dd/MM/yyyy HH:mm'}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 50, 500, 1000]" showFirstLastButtons></mat-paginator>

  </mat-expansion-panel>
</mat-accordion>
